module.exports = __webpack_public_path__ + "img/zn.bb805071.jpg";